// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"059b9671","280":"92ef1645","887":"97c0bff0"}[chunkId] + ".chunk.js";
};